import $axios from "../../api";
import Vue from 'vue';
import FileSaver from "file-saver";

const PERF_POLL_INTERVAL_MS = 3000;
const PERF_POLL_MAX_ATTEMPTS = 60;

const state = () => ({
  cardStatistics: {},
  cardStatisticsLoading: false,

  graphStatistics: {},
  graphStatisticsLoading: false,

  retailPerformance: {
    app: null,
    website: null,
    store: null,
  },
  retailLoading: false,

  ecommerce: {},
  ecommerceStatisticLoading: false,
  ecommercePerformanceLoading: false,
  ecommerceErrors: {},

  // store: {},
  // storeLoading: false,
  // storeSuccess: false,
  // storeErrors: null,

  storeStatistics: {},
  storeStatisticsLoading: false,
  storeStatisticsSuccess: false,
  storeStatisticsErrors: null,

  storeTopStores: {},
  storeTopStoresLoading: false,
  storeTopStoresSuccess: false,
  storeTopStoresErrors: null,

  storeDetails: {},
  storeDetailsLoading: false,
  storeDetailsSuccess: false,
  storeDetailsErrors: null,

  reseller: {},
  resellerLoading: false,
  resellerSuccess: false,
  resellerErrors: null,

  storeList: [],
  storeListLoading: false,

  memberStatistic: {},
  memberStatisticLoading: false,

  topKeywords: {},
  topKeywordsLoading: false,

  // lvl 3 state
  isLoading: false,
  isLoadingTable: false,
  isLoadingExport: false,
  page: 1,

  performRateData: null,
  performVisitData: null,
  performCartData: null,
  performOrdersData: null,
  topCategoryData: null,
  topBrandData: null,
  topMemberData: null,
  topMemberOverview: null,
  InActiveMemberData: null,
  topPaymentData: null,
  topVoucherData: null,
  topVoucherOverview: {},

  // lvl 4 state
  isLoadingDetail: false,
  pageDetail: 1,

  performVisitDetail: null,
  performCartDetail: null,
  performOrderDetail: null,
  topCategoryDetail: null,
  topBrandDetail: null,
  topPaymentDetail: null,
  topVoucherDetail: null,
})

const getters = {
  // Transform ecommerce data from state
  getTransformedEcommerceData: (state) => {
    const data = {
      last_update: state.ecommerce[0]?.data.data.last_update,
      statistics_sales: state.ecommerce[0]?.data.data.statistics_sales,
      app: {
        top_buyers: state.ecommerce[0]?.data.data.top_buyers,
        top_product: state.ecommerce[0]?.data.data.top_product,
        top_category: state.ecommerce[0]?.data.data.top_category,
        top_brand: state.ecommerce[0]?.data.data.top_brand
      },
      website: {
        top_buyers: state.ecommerce[1]?.data.data.top_buyers,
        top_product: state.ecommerce[1]?.data.data.top_product,
        top_category: state.ecommerce[1]?.data.data.top_category,
        top_brand: state.ecommerce[1]?.data.data.top_brand
      },
      tiktok: {
        top_buyers: state.ecommerce[2]?.data.data.top_buyers,
        top_product: state.ecommerce[2]?.data.data.top_product,
        top_category: state.ecommerce[2]?.data.data.top_category,
        top_brand: state.ecommerce[2]?.data.data.top_brand
      }
    };

    return data;
  },

  // Get filtered chart data based on selected checkboxes
  // This getter takes selectedCheckbox as a parameter and returns filtered chart data
  // It automatically re-evaluates when state.ecommerce changes or when selectedCheckbox changes
  getFilteredChartData: (state) => (selectedCheckbox) => {
    // Ensure we have the required data 
    if (!state.graphStatistics) {
      return {
        labels: [],
        datasets: []
      }
    }

    const chartData = state.graphStatistics;
    const datasets = chartData.datasets || [];
    const labels = chartData.labels || [];

    // Filter datasets based on selected checkboxes
    const filteredDatasets = datasets.filter(dataset =>
      selectedCheckbox.includes(dataset.label)
    );

    return {
      labels: labels,
      datasets: filteredDatasets
    };
    // if (!state.ecommerce?.statistics_sales?.statisticChartData) {
    //   return {
    //     labels: [],
    //     datasets: []
    //   };
    // }

    // const chartData = state.ecommerce.statistics_sales.statisticChartData;
    // const datasets = chartData.datasets || [];
    // const labels = chartData.labels || [];

    // const filteredDatasets = datasets.filter(dataset =>
    //   selectedCheckbox.includes(dataset.label)
    // );

    // return {
    //   labels: labels,
    //   datasets: filteredDatasets
    // };
  }
}

const mutations = {
  SET_CARD_STATISTICS_LOADING(state, payload) {
    state.cardStatisticsLoading = payload;
  },
  ASSIGN_CARD_STATISTICS_DATA(state, payload) {
    state.cardStatistics = payload;
  },
  SET_GRAPH_STATISTICS_LOADING(state, payload) {
    state.graphStatisticsLoading = payload;
  },
  ASSIGN_GRAPH_STATISTICS_DATA(state, payload) {
    state.graphStatistics = payload;
  },
  SET_RETAIL_LOADING(state, payload) {
    state.retailLoading = payload;
  },
  ASSIGN_RETAIL_PERFORMANCE_DATA(state, payload) {
    Vue.set(state.retailPerformance, payload.platform, payload.data);
  },
  SET_ECOMMERCE_STATISTIC_LOADING(state, payload) {
    state.ecommerceStatisticLoading = payload;
  },
  SET_ECOMMERCE_PERFORMANCE_LOADING(state, payload) {
    state.ecommercePerformanceLoading = payload;
  },
  ASSIGN_ECOMMERCE_ERRORS(state, payload) {
    state.ecommerceErrors = payload;
  },
  ASSIGN_ECOMMERCE_STATISTIC_DATA(state, payload) {
    Vue.set(state.ecommerce, 'statistics_sales', payload);
  },
  ASSIGN_ECOMMERCE_PERFORMANCE_DATA(state, payload) {
    state.ecommerce[payload.platform] = payload.data
  },
  SET_STORE_LOADING(state, payload) {
    state.storeLoading = payload;
  },
  SET_STORE_SUCCESS(state, payload) {
    state.storeSuccess = payload;
  },
  ASSIGN_STORE_ERRORS(state, payload) {
    state.storeErrors = payload;
  },
  ASSIGN_STORE_DATA(state, payload) {
    state.store = payload
  },
  SET_RESELLER_LOADING(state, payload) {
    state.resellerLoading = payload;
  },
  SET_RESELLER_SUCCESS(state, payload) {
    state.resellerSuccess = payload;
  },
  ASSIGN_RESELLER_ERRORS(state, payload) {
    state.resellerErrors = payload;
  },
  ASSIGN_RESELLER_DATA(state, payload) {
    state.reseller = payload
  },
  SET_STORE_LIST_LOADING(state, payload) {
    state.storeListLoading = payload;
  },
  ASSIGN_STORE_LIST_DATA(state, payload) {
    state.storeList = payload
  },
  //Store
  SET_STATISTICS_LOADING(state, payload) {
    state.storeStatisticsLoading = payload;
  },
  SET_STATISTICS_SUCCESS(state, payload) {
    state.storeStatisticsSuccess = payload;
  },
  ASSIGN_STATISTICS_ERRORS(state, payload) {
    state.storeStatisticsErrors = payload;
  },
  ASSIGN_STATISTICS_DATA(state, payload) {
    state.storeStatistics = payload;
  },

  SET_TOP_STORES_LOADING(state, payload) {
    state.storeTopStoresLoading = payload;
  },
  SET_TOP_STORES_SUCCESS(state, payload) {
    state.storeTopStoresSuccess = payload;
  },
  ASSIGN_TOP_STORES_ERRORS(state, payload) {
    state.storeTopStoresErrors = payload;
  },
  ASSIGN_TOP_STORES_DATA(state, payload) {
    state.storeTopStores = payload;
  },

  SET_DETAILS_LOADING(state, payload) {
    state.storeDetailsLoading = payload;
  },
  SET_DETAILS_SUCCESS(state, payload) {
    state.storeDetailsSuccess = payload;
  },
  ASSIGN_DETAILS_ERRORS(state, payload) {
    state.storeDetailsErrors = payload;
  },
  ASSIGN_DETAILS_1_DATA(state, payload) {
    state.storeDetails['top_buyers'] = payload['top_buyers'];
    state.storeDetails['top_product'] = payload['top_product'];
  },
  ASSIGN_DETAILS_2_DATA(state, payload) {
    state.storeDetails['top_category'] = payload['top_category'];
    state.storeDetails['top_brand'] = payload['top_brand'];
  },
  SET_MEMBER_STATISTIC_LOADING(state, payload) {
    state.memberStatisticLoading = payload;
  },
  ASSIGN_MEMBER_STATISTIC_DATA(state, payload) {
    state.memberStatistic = payload;
  },
  ASSIGN_TOP_KEYWORD_DATA(state, payload) {
    state.topKeywords = payload;
  },
  SET_TOP_KEYWORD_LOADING(state, payload) {
    state.topKeywordsLoading = payload;
  },

  // lvl 3 mutations
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_LOADING_TABLE(state, payload) {
    state.isLoadingTable = payload;
  },
  SET_LOADING_EXPORT(state, payload) {
    state.isLoadingExport = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_PERFORMRATE_DATA(state, payload) {
    state.performRateData = payload;
  },
  SET_PERFORMVISIT_DATA(state, payload) {
    state.performVisitData = payload;
  },
  SET_PERFORMCART_DATA(state, payload) {
    state.performCartData = payload;
  },
  SET_PERFORMORDERS_DATA(state, payload) {
    state.performOrdersData = payload;
  },
  SET_TOPCATEGORY_DATA(state, payload) {
    state.topCategoryData = payload;
  },
  SET_TOPBRAND_DATA(state, payload) {
    state.topBrandData = payload;
  },
  SET_TOPMEMBER_DATA(state, payload) {
    state.topMemberData = payload;
  },
  SET_TOPMEMBER_OVERVIEW(state, payload) {
    state.topMemberOverview = payload;
  },
  SET_INACTIVEMEMBER_DATA(state, payload) {
    state.InActiveMemberData = payload;
  },
  SET_TOPPAYMENT_DATA(state, payload) {
    state.topPaymentData = payload;
  },
  SET_TOPPAYMENT_OVERVIEW(state, payload) {
    state.topPaymentOverview = payload;
  },
  SET_TOPVOUCHER_DATA(state, payload) {
    state.topVoucherData = payload;
  },
  SET_TOPVOUCHER_OVERVIEW(state, payload) {
    state.topVoucherOverview = payload;
  },

  // lvl 4 mutations
  SET_LOADING_DETAIL(state, payload) {
    state.isLoadingDetail = payload;
  },
  SET_PAGE_DETAIL(state, payload) {
    state.pageDetail = payload;
  },
  SET_PERFORMVISIT_DETAIL(state, payload) {
    state.performVisitDetail = payload;
  },
  SET_PERFORMCART_DETAIL(state, payload) {
    state.performCartDetail = payload;
  },
  SET_PERFORMORDER_DETAIL(state, payload) {
    state.performOrderDetail = payload;
  },
  SET_TOPCATEGORY_DETAIL(state, payload) {
    state.topCategoryDetail = payload;
  },
  SET_TOPBRAND_DETAIL(state, payload) {
    state.topBrandDetail = payload;
  },
  SET_TOPPAYMENT_DETAIL(state, payload) {
    state.topPaymentDetail = payload;
  },
  SET_TOPVOUCHER_DETAIL(state, payload) {
    state.topVoucherDetail = payload;
  },
}

const actions = {
  getCardStatistics({ commit, state, rootState, dispatch }, payload) {
    commit("SET_CARD_STATISTICS_LOADING", true)
    return new Promise((resolve, reject) => {
      $axios.get(`main/dash/1/statistic/card`, {
        params: {
          start_date: payload?.start_date,
          end_date: payload?.end_date,
        }
      })
        .then(({ data }) => {
          commit("ASSIGN_CARD_STATISTICS_DATA", data.data)
          resolve()
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        })
        .finally(() => {
          commit("SET_CARD_STATISTICS_LOADING", false)
        })
    })
  },
  getGraphStatistics({ commit, state, rootState, dispatch }, payload) {
    commit("SET_GRAPH_STATISTICS_LOADING", true)
    return new Promise((resolve, reject) => {
      $axios.get(`main/dash/1/statistic/graph`, {
        params: {
          start_date: payload?.start_date,
          end_date: payload?.end_date,
        }
      })
        .then(({ data }) => {
          commit("ASSIGN_GRAPH_STATISTICS_DATA", data.data)
          resolve()
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        })
        .finally(() => {
          commit("SET_GRAPH_STATISTICS_LOADING", false)
        })
    })
  },
  getRetailPerformance({ commit, state, rootState, dispatch }, payload) {
    commit("SET_RETAIL_LOADING", true)
    return new Promise((resolve, reject) => {
      $axios.get(`main/dash/1/list/retail`, {
        params: {
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          platform: payload?.platform
        }
      })
        .then(({ data }) => {
          commit("ASSIGN_RETAIL_PERFORMANCE_DATA", { data: { ...data.data, start_date: payload?.start_date, end_date: payload?.end_date }, platform: payload?.platform })
          resolve()
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        })
        .finally(() => {
          commit("SET_RETAIL_LOADING", false)
        })
    });
  },
  async getEcommerceStatisticData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_ECOMMERCE_STATISTIC_LOADING", true)
    try {
      const { data } = await $axios.get(`main/dash/1/ecommerce/statistic`, {
        params: {
          start_date: payload?.start_date,
          end_date: payload?.end_date,
        }
      })

      commit('ASSIGN_ECOMMERCE_STATISTIC_DATA', data.data)
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_ECOMMERCE_STATISTIC_LOADING", false)
    }
  },
  async getEcommercePerformanceData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_ECOMMERCE_PERFORMANCE_LOADING", true)

    try {
      const { data } = await $axios.get(`main/dash/1/ecommerce/performance-buyer-and-product`, {
        params: {
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          platform: payload?.platform
        }
      })

      commit('ASSIGN_ECOMMERCE_PERFORMANCE_DATA', { data: data.data, platform: payload?.platform })
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_ECOMMERCE_PERFORMANCE_LOADING", false)
    }
  },
  // async getEcommerceStatisticData({ commit, state, rootState, dispatch }, payload) {
  //   commit("SET_ECOMMERCE_STATISTIC_LOADING", true)
  //   try {
  //     const response = await Promise.all([
  //       $axios.get(`main/dash/1/ecommerce`, {
  //         params: {
  //           start_date: payload?.start_date,
  //           end_date: payload?.end_date,
  //           platform: 'app'
  //         }
  //       }),
  //       $axios.get(`main/dash/1/ecommerce`, {
  //         params: {
  //           start_date: payload?.start_date,
  //           end_date: payload?.end_date,
  //           platform: 'website'
  //         }
  //       }),
  //       $axios.get(`main/dash/1/ecommerce`, {
  //         params: {
  //           start_date: payload?.start_date,
  //           end_date: payload?.end_date,
  //           platform: 'tiktok'
  //         }
  //       })
  //     ]);

  //     commit("ASSIGN_ECOMMERCE_DATA", response)
  //     commit("SET_ECOMMERCE_SUCCESS", true);
  //   } catch (error) {
  //     dispatch("Main/globalSweetAlert", "Something went wrong, please try again later", { root: true });
  //   } finally {
  //     commit("SET_ECOMMERCE_LOADING", false)
  //   }
  // },

  async getStoreDashboardData({ commit, state, rootState, dispatch }, { section, payload }) {

    const validSections = [
      'statistics',
      'top_stores',
      'details'
    ];

    if (!validSections.includes(section)) {
      console.error(`Invalid section provided: ${section}`);
      dispatch("Main/globalSweetAlert", {
        status: 400,
        data: { message: `Bagian dashboard tidak valid: ${section}` }
      }, { root: true });
      return;
    }

    const loadingMutation = `SET_${section.toUpperCase()}_LOADING`;
    const successMutation = `SET_${section.toUpperCase()}_SUCCESS`;
    const errorMutation = `ASSIGN_${section.toUpperCase()}_ERRORS`;
    const dataAssignmentMutation = `ASSIGN_${section.toUpperCase()}_DATA`;

    commit(loadingMutation, true);
    commit(successMutation, false);
    commit(errorMutation, null);

    try {
      if (section === 'details') {
        const [firstResponse, secondResponse] = await Promise.all([
          $axios.get(`main/dash/1/store/${section}-1`, {
            params: {
              store: payload?.store,
              start_date: payload?.start_date,
              end_date: payload?.end_date,
            }
          }),
          $axios.get(`main/dash/1/store/${section}-2`, {
            params: {
              store: payload?.store,
              start_date: payload?.start_date,
              end_date: payload?.end_date,
            }
          })
        ]);

        commit('ASSIGN_DETAILS_1_DATA', firstResponse.data.data);
        commit('ASSIGN_DETAILS_2_DATA', secondResponse.data.data);
        commit(successMutation, true);
      } else {
        const { data } = await $axios.get(`main/dash/1/store/${section}`, {
          params: {
            store: payload?.store,
            start_date: payload?.start_date,
            end_date: payload?.end_date,
          }
        })

        commit(successMutation, true);
        commit(dataAssignmentMutation, data.data);
      }
    } catch (error) {
      commit(errorMutation, error.response || error);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(loadingMutation, false);
    }
  },

  async getResellerDashboardData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_RESELLER_LOADING", true);
    try {
      const { data } = await $axios.get(`main/dash/1/list/reseller`, {
        params: {
          start_date: payload?.start_date,
          end_date: payload?.end_date,
        }
      })

      commit("ASSIGN_RESELLER_DATA", data.data)
      commit("SET_RESELLER_SUCCESS", true);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_RESELLER_LOADING", false);
    }
  },

  async getStoreList({ commit, state, rootState, dispatch }, payload) {
    commit('SET_STORE_LIST_LOADING', true)
    try {
      const { data } = await $axios.get(`main/dash/store-list`, {
        params: {
          search: payload?.search,
        }
      })

      commit("ASSIGN_STORE_LIST_DATA", data.data)
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit('SET_STORE_LIST_LOADING', false)
    }
  },

  getMemberStatistic({ commit, dispatch }, payload) {
    commit("SET_MEMBER_STATISTIC_LOADING", true)
    return new Promise((resolve, reject) => {
      $axios.get(`main/dash/1/member-statistic`, {
        params: {
          tab: payload?.tab,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
        }
      })
        .then(({ data }) => {
          commit("ASSIGN_MEMBER_STATISTIC_DATA", data.data)
          resolve()
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, { root: true })
          reject(error)
        })
        .finally(() => {
          commit("SET_MEMBER_STATISTIC_LOADING", false)
        })
    })
  },

  async getMemberStatisticDetail({ commit, dispatch }, payload = {}) {
    try {
      commit("SET_MEMBER_STATISTIC_LOADING", true)
      const { data } = await $axios.get(
        "main/dash/3/member-statistic",
        {
          params: {
            start_date: payload.start_date,
            end_date: payload.end_date
          }
        }
      )
      commit("ASSIGN_MEMBER_STATISTIC_DATA", data.data)
    } catch (error) {
      dispatch(
        "Main/globalSweetAlert",
        error?.response,
        { root: true }
      )
      throw error
    } finally {
      commit("SET_MEMBER_STATISTIC_LOADING", false)
    }
  },

  getTopKeywords({ commit, dispatch }, payload) {
    commit("SET_TOP_KEYWORD_LOADING", true)
    return new Promise((resolve, reject) => {
      $axios.get(`main/dash/1/top-keyword`, {
        params: {
          start_date: payload?.start_date,
          end_date: payload?.end_date,
        }
      })
        .then(({ data }) => {
          commit("ASSIGN_TOP_KEYWORD_DATA", data.data)
          resolve()
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, { root: true })
          reject(error)
        })
        .finally(() => {
          commit("SET_TOP_KEYWORD_LOADING", false)
        })
    })
  },
  // lvl 3 actions
  async getPerformanceData({ commit, state, rootState, dispatch }, { payload, type }) {
    if (type === "rate") {
      commit("SET_LOADING", true);
    } else {
      commit("SET_LOADING_TABLE", true);
    }
    if (!type) {
      dispatch("Main/globalSuccessSweetAlert", "Endpoint Salah", {
        root: true,
      });
      commit("SET_LOADING", false);
      commit("SET_LOADING_TABLE", false);
      return Promise.reject("Endpoint Salah");
    }

    const url = `main/dash/3/performance-${type}?page=${state.page}&view=${rootState.Main.view}${payload || ""}`;
    const pollable = type === "visit" || type === "cart";
    const maxAttempts = pollable ? PERF_POLL_MAX_ATTEMPTS : 1;

    try {
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        const res = await $axios.get(url);

        if (res.status === 202) {
          const wait = res.data?.retry_after_ms ?? PERF_POLL_INTERVAL_MS;
          await new Promise((r) => setTimeout(r, wait));
          continue;
        }

        if (type === "rate") {
          commit("SET_PERFORMRATE_DATA", res.data);
          commit("SET_LOADING", false);
        } else if (type === "visit") {
          commit("SET_PERFORMVISIT_DATA", res.data);
          commit("SET_LOADING_TABLE", false);
        } else if (type === "cart") {
          commit("SET_PERFORMCART_DATA", res.data);
          commit("SET_LOADING_TABLE", false);
        } else if (type === "orders") {
          commit("SET_PERFORMORDERS_DATA", res.data);
          commit("SET_LOADING_TABLE", false);
        }
        return res.data;
      }

      commit("SET_LOADING", false);
      commit("SET_LOADING_TABLE", false);
      const timeoutErr = new Error(
        `performance-${type} timed out after ${(maxAttempts * PERF_POLL_INTERVAL_MS) / 1000}s`
      );
      dispatch(
        "Main/globalSweetAlert",
        { data: { message: timeoutErr.message } },
        { root: true }
      );
      throw timeoutErr;
    } catch (error) {
      commit("SET_LOADING", false);
      commit("SET_LOADING_TABLE", false);
      if (error.response) {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
      }
      throw error;
    }
  },
  getTopCategoryData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/3/category?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPCATEGORY_DATA", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopBrandData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/3/brand?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPBRAND_DATA", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopMemberData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/3/customers-perform?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPMEMBER_DATA", res.data.data);
          commit("SET_TOPMEMBER_OVERVIEW", {
            total_member: res.data.total_member,
            total_green_member: res.data.total_green_member,
            total_silver_member: res.data.total_silver_member,
            total_gold_member: res.data.total_gold_member,
            total_platinum_member: res.data.total_platinum_member,
          });
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getInactiveMemberData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/3/customers-notperform?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_INACTIVEMEMBER_DATA", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
    getTopPaymentData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/3/payment?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          const dataList = res.data.data;
          commit("SET_TOPPAYMENT_DATA", dataList);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopVoucherData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/3/promotions?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPVOUCHER_DATA", res.data.data);
          commit("SET_TOPVOUCHER_OVERVIEW", {
            count_order: res.data.count_order,
            count_member: res.data.count_member,
            count_transaction: res.data.count_transaction,
          });
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  // lvl 4 actions
  getTopCategoryDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/4/category?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPCATEGORY_DETAIL", res.data);
          commit("SET_LOADING_DETAIL", false);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },  
  getTopBrandDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/4/brand?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPBRAND_DETAIL", res.data);
          commit("SET_LOADING_DETAIL", false);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },  
  getPerformanceCartDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/4/performance-cart?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_PERFORMCART_DETAIL", res.data);
          commit("SET_LOADING_DETAIL", false);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getPerformanceOrderDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/4/performance-orders?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_PERFORMORDER_DETAIL", res.data);
          commit("SET_LOADING_DETAIL", false);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getPerformanceVisitDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/4/performance-visit?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_PERFORMVISIT_DETAIL", res.data);
          commit("SET_LOADING_DETAIL", false);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getTopVoucherDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/4/promotions?page=${state.pageDetail}&view=${rootState.Main.view}${payload || ""}`
        )
        .then((res) => {
          commit("SET_TOPVOUCHER_DETAIL", res.data);
          commit("SET_LOADING_DETAIL", false);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  // export actions
  exportCustPerform({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_EXPORT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/export/customers-perform?view=${rootState.Main.view}${payload || ""}`,
          { responseType: "blob" }
        )
        .then((res) => {
          FileSaver.saveAs(
            res.data,
            `customersPerform_view=${rootState.Main.view}${payload || ""}_${new Date()}.xlsx`
          );
          commit("SET_LOADING_EXPORT", false);
          resolve();
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  exportCustNotPerform({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_EXPORT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/export/customers-notperform?view=${rootState.Main.view}${payload || ""}`,
          { responseType: "blob" }
        )
        .then((res) => {
          FileSaver.saveAs(
            res.data,
            `customersNotPerform_view=${rootState.Main.view}${payload || ""}_${new Date()}.xlsx`
          );
          commit("SET_LOADING_EXPORT", false);
          resolve();
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  exportCategory({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_EXPORT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/export/category?view=${rootState.Main.view}${payload || ""}`,
          { responseType: "blob" }
        )
        .then((res) => {
          FileSaver.saveAs(
            res.data,
            `category_view=${rootState.Main.view}${payload || ""}_${new Date()}.xlsx`
          );
          commit("SET_LOADING_EXPORT", false);
          resolve();
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  exportBrand({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_EXPORT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/export/brand?view=${rootState.Main.view}${payload || ""}`,
          { responseType: "blob" }
        )
        .then((res) => {
          FileSaver.saveAs(
            res.data,
            `brand_view=${rootState.Main.view}${payload || ""}_${new Date()}.xlsx`
          );
          commit("SET_LOADING_EXPORT", false);
          resolve();
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  exportPerformanceOrders({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_EXPORT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/export/performance-orders?view=${rootState.Main.view}${payload || ""
          }`,
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          FileSaver.saveAs(
            res.data,
            `performanceOrders_view=${rootState.Main.view}${payload || ""
            }_${new Date()}.xlsx`
          );
          commit("SET_LOADING_EXPORT", false);
          resolve()
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  exportPerformanceCart({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_EXPORT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/export/performance-cart?view=${rootState.Main.view}${payload || ""
          }`,
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          FileSaver.saveAs(
            res.data,
            `performanceCart_view=${rootState.Main.view}${payload || ""
            }_${new Date()}.xlsx`
          );
          commit("SET_LOADING_EXPORT", false);
          resolve()
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  exportPerformanceVisit({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_EXPORT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/export/performance-visit?view=${rootState.Main.view}${payload || ""
          }`,
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          FileSaver.saveAs(
            res.data,
            `performanceVisit_view=${rootState.Main.view}${payload || ""
            }_${new Date()}.xlsx`
          );
          commit("SET_LOADING_EXPORT", false);
          resolve()
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  exportPaymentMethod({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_EXPORT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/export/payment-method?view=${rootState.Main.view}${payload || ""}`,
          { responseType: "blob" }
        )
        .then((res) => {
          FileSaver.saveAs(
            res.data,
            `paymentMethod_view=${rootState.Main.view}${payload || ""}_${new Date()}.xlsx`
          );
          commit("SET_LOADING_EXPORT", false);
          resolve();
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  exportPromotions({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_EXPORT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/export/promotions?view=${rootState.Main.view}${payload || ""}`,
          { responseType: "blob" }
        )
        .then((res) => {
          FileSaver.saveAs(
            res.data,
            `promotions_view=${rootState.Main.view}${payload || ""}_${new Date()}.xlsx`
          );
          commit("SET_LOADING_EXPORT", false);
          resolve();
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  exportCustPerformDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_EXPORT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `main/dash/export/customers-perform-detail?view=${rootState.Main.view}${payload || ""}`,
          { responseType: "blob" }
        )
        .then((res) => {
          FileSaver.saveAs(
            res.data,
            `customersPerformDetail_view=${rootState.Main.view}${payload || ""}_${new Date()}.xlsx`
          );
          commit("SET_LOADING_EXPORT", false);
          resolve();
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}